export default __webpack_public_path__ + "static/media/07AW1AUG66.92201893.jpg";